import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { DropdownContainer, DropdownItem, InputField } from '../../Profile.styles';

interface IProps {
    value: string;
    onChange: (address: string) => void;
    onSelect: (address: string, placeId: string) => Promise<void>;
}

const AddressInput: React.FunctionComponent<IProps> = ({ value, onChange, onSelect }) => 
{
    return (
        <PlacesAutocomplete value={value} onChange={onChange} onSelect={onSelect}>
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <>
                    <InputField {...getInputProps({
                        placeholder: '100 King Street West, Toronto, ON, Canada',
                        className: 'location-search-input',
                    })} />
                    <DropdownContainer>
                        {!loading && suggestions.map(suggestion => (
                            <DropdownItem {...getSuggestionItemProps(suggestion)} key={suggestion.placeId}>
                                <span>{suggestion.description}</span>
                            </DropdownItem>
                        ))}
                    </DropdownContainer>
                </>
            )}
        </PlacesAutocomplete>
    );
};

export default AddressInput;
